<template>
  <div @click="$router.push(`/alumn/${alumn.specialId}`)" class="alumn-item">
    <div class="alumn-content">
      <div class="cover">
        <div class="count">
          <i class="iconfont iconshipin2"></i>
          <span>{{ alumn.resourceCount }}</span>
        </div>
        <img v-if="alumn.specialPic" :src="$isCdn(alumn.specialPic)" alt="" />
        <img v-else src="./../../../assets/image/rec_1.png" alt="" />
      </div>
      <div class="info">
        <div class="title van-multi-ellipsis--l2">
          {{ alumn.specialName }}
        </div>
        <div class="user">
          <span>{{ alumn.userName }}</span>
          <span class="c">
            <i class="iconfont iconguankan"></i>
            <span>{{ alumn.visitCount }}</span>
          </span>
          <span class="c">
            <i class="iconfont iconpingxing1"></i>
            <span>{{ alumn.avgScore.toFixed(1) }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="desc">
      <div class="van-multi-ellipsis--l2" v-if="alumn.specialMask">{{ alumn.specialMask }}</div>
      <div v-else>暂无简介</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['alumn']
}
</script>

<style lang="scss" scoped>
.alumn-item {
  padding: 16px 14px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 0px 12px 0px rgba(23, 38, 71, 0.04);
}
.alumn-item + .alumn-item {
  margin-top: 16px;
}
.alumn-content {
  display: flex;
  .cover {
    position: relative;
    width: 120px;
    height: 70px;
    border-radius: 4px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .cover .count {
    position: absolute;
    left: 6px;
    top: 6px;
    height: 20px;
    background: rgba(0, 5, 32, 0.4);
    border-radius: 15px;
    padding: 0 6px;
    color: #fff;
    display: flex;
    align-items: center;
    span {
      margin-left: 3px;
      font-size: 10px;
    }
  }

  .info {
    margin-left: 12px;
    flex: 1;
    width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      color: #303133;
      font-weight: 500;
      font-size: 15px;
    }
    .user {
      color: #909399;
      font-size: 12px;
      display: flex;
      align-items: center;
      .c {
        margin-left: 10px;
        display: inline-flex;
        align-items: center;
      }
      .c span {
        margin-left: 4px;
      }
    }
  }
}

.desc {
  margin-top: 12px;
  padding: 12px 10px;
  border-radius: 4px;
  background: #fafbfc;
  color: #909399;
  font-size: 14px;
  word-break: break-all;
}
</style>
